/**
 * 媒资取签记录
 * he.jianbo
 */

angular.module('resourceCenterMaterialModule').controller('mediaTakeRecordCtrl', [
    '$scope',
    'mrApiService',
    'options',
    '$modalInstance',
    '$timeout',
    function($scope, mrApiService, options, $modalInstance,  $timeout) {
        initStatus();
        initData();

        /**
         * [initStatus 初始化数据]
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.windowTitle = '取签记录';
            $scope.data = {
                navs: [
                    {
                        name: '取',
                        value: '1',
                    },
                    {
                        name: '签',
                        value: '2',
                    },
                ],
                selectedNav: '1',
            };
            $scope.params = {
                mrType: options.mrType,
                mainResourceType: options.mainResourceType,
                relationId: options.relationId,
                operation: options.operation,
            };
            $scope.items = [];
            $scope.signedTtems = [];
        }

         /**
         * [getAutoHeight description] 居中提示文字
         * @return {[type]} [description]
         */
        $scope.getAutoHeight = function() {
            $timeout(function() {
                var bodyHeight = $('.publicModal .body').height(),
                    fixedAreaHeight = $('.fixedArea').height();
                var contentHeight = bodyHeight - fixedAreaHeight;
                $('.recordList').height(contentHeight);
            }, 500);
        };

        /**
         * [initData 初始化数据]
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            requestData();
        }

        /**
         * [requestData 请求数据]
         *
         * @return  {[type]}  [return description]
         */
        function requestData() {
            $scope.loadingPromise = mrApiService.getTakeRecords($scope.params).then(function(data){
                if (data.code === '200') {
                    $scope.items = data.datas;
                }
            });
        }

        /**
         * [changeNav 切换标签]
         *
         * @param   {[type]}  nav  [nav description]
         *
         * @return  {[type]}       [return description]
         */
        $scope.changeNav = function(nav) {
            $scope.data.selectedNav = nav.value;
            if (nav.value === '2') {
                $scope.getAutoHeight();
                $scope.params.operation = 'publish';
                $scope.items = [];
            } else {
                $scope.params.operation = 'fetch';
                $scope.items = [];
            }
            requestData();
        };

        /**
         * [close description] 取消
         * @return {[type]} [description]
         */
        $scope.close = function() {
            $modalInstance.dismiss();
        };
    },
]);
